export default "__VITE_ASSET__99b093af__"